import { ValueInteraction } from "./ValueInteraction";
import { TileCoordinates } from "../../runescape/coordinates";
import InteractionTopControl from "../../../cluetrainer/ui/map/InteractionTopControl";
export class SelectTileInteraction extends ValueInteraction {
    constructor(config = {}, conf = { snap: 1, shift_snap: 1 }) {
        super(config);
        this.config = config;
        this.conf = conf;
    }
    coordinatesOfEvent(event) {
        const granularity = event.original.shiftKey ? (this.conf.shift_snap ?? 1) : (this.conf.snap ?? 1);
        return TileCoordinates.snap(event.coordinates, granularity);
    }
    eventHover(event) {
        super.eventHover(event);
        event.onPre(() => {
            this.preview(this.coordinatesOfEvent(event));
        });
    }
    eventClick(event) {
        event.onPre(() => {
            event.stopAllPropagation();
            this.commit(this.coordinatesOfEvent(event));
        });
    }
}
(function (SelectTileInteraction) {
    class Standalone extends SelectTileInteraction {
        constructor(config = {}, off_tile = "never") {
            super(config, {
                "always": { snap: 0, shift_snap: 0 },
                "never": { snap: 1, shift_snap: 1 },
                "optional": { snap: 1, shift_snap: 0 },
            }[off_tile]);
            this.off_tile = off_tile;
            switch (this.off_tile) {
                case "never":
                    this.attachTopControl(new InteractionTopControl({ name: "Select Tile" }).setText("Click a tile to select it."));
                    break;
                case "optional":
                    this.attachTopControl(new InteractionTopControl({ name: "Select Tile" }).setContent(c("<div style='font-family: monospace; white-space:pre'></div>")
                        .append(c().text(`Hold [Shift] to disable snapping`))));
                    break;
                case "always":
                    this.attachTopControl(new InteractionTopControl({ name: "Select Coordinates" }).setText("Click the map to select coordinates."));
            }
        }
    }
    SelectTileInteraction.Standalone = Standalone;
})(SelectTileInteraction || (SelectTileInteraction = {}));
